import { type FC } from 'react'
import styled from 'styled-components'

import { Tooltip } from '@/components/global/Tooltip/Tooltip'
import { Icon } from '@/components/priority/Icon/Icon'

const WarningIcon = styled.div`
  padding: 2px;
  margin: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

type InlineWarningTooltipProps = {
  message: string
  width?: string
  ariaLabel?: string
  testId?: string
  /** Stamped as `data-warning-key`: which phrase the tooltip shows, for tests that must not depend on copy. */
  warningKey?: string
}

/**
 * Reusable inline warning tooltip for the ItemControlOverlay.
 * Renders a warning icon with a hover tooltip.
 * Used by WarningIndicators for PPI and bleed warnings.
 */
export const InlineWarningTooltip: FC<InlineWarningTooltipProps> = ({
  message,
  width = '150px',
  ariaLabel,
  testId,
  warningKey,
}) => {
  return (
    <Tooltip
      text={message}
      placement="right"
      offsetX={10}
      width={width}
      height="fit-content"
    >
      <WarningIcon
        aria-label={ariaLabel || message}
        data-testid={testId}
        data-warning-key={warningKey}
      >
        <Icon
          icon="exclamationTriangle"
          width="24px"
          height="24px"
          fill="orange"
        />
      </WarningIcon>
    </Tooltip>
  )
}
